import { render, staticRenderFns } from "./SelectShippingDirectSale.vue?vue&type=template&id=f6ea6304&"
import script from "./SelectShippingDirectSale.vue?vue&type=script&lang=js&"
export * from "./SelectShippingDirectSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports